// extracted by mini-css-extract-plugin
module.exports = {"role-text":"_3Wh4em9MA1vU8rKuD7p1fz","container":"TUXMJZXZ5fYxfXawI55Se"};